import { View } from "@react-pdf/renderer";
import { spacing } from "components/Resume/ResumePDF/styles";
import { ResumePDFText, ResumePDFHighlightableText } from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection } from "./common";
import type { ResumeProfile } from "lib/redux/types";

export const Summary = ({
  profile,
  themeColor,
  heading,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  profile: ResumeProfile;
  themeColor: string;
  heading: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  const { summary } = profile;

  return (
    <TemplateTwoPDFSection themeColor={themeColor} heading={heading}>
      <View wrap={false}>{summary && ((enableHighlight || enableMistakeHighlight) ? (
        <ResumePDFHighlightableText
          text={summary}
          section="profile"
          itemIndex={null}
          enableMistakeHighlight={enableMistakeHighlight}
        />
      ) : (
        <ResumePDFText>{summary}</ResumePDFText>
      ))}</View>
    </TemplateTwoPDFSection>
  );
};
